module.exports = __webpack_public_path__ + "static/img/bg3.ed7490a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg3.jpg
// module id = uEGs
// module chunks = 0